module.exports = "/assets/dist/img/facebook-circle.png?3439228ffb4291f7856c7f76e6a7c32d";


//////////////////
// WEBPACK FOOTER
// ./WebResources/vue/grad-images/site-footer/assets/facebook-circle.png
// module id = 1767
// module chunks = 27